import { memoize } from "lodash";
import { observable } from "mobx";
import { apiCallGetUserAIDescriptions } from "../../../api/user-api/api-call-get-user-ai-descriptions";
import { TUserAIDescriptionsData } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class AIDescriptionsStore {
  userIDInput = observable.box<number>(0);
  userAIDescriptions = observable.box<TUserAIDescriptionsData>([]);

  getUserAIDescriptions = async () => {
    getCoreUIStore().setIsLoading("USER_AI_DESCRIPTIONS", true);
    const { status, data, code } = await apiCallGetUserAIDescriptions({
      userID: this.userIDInput.get()
    });
    getCoreUIStore().setIsLoading("USER_AI_DESCRIPTIONS", false);
    if (status === "OK") {
      this.userAIDescriptions.set(data);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getAIDescriptionsStore = memoize(
  () => new AIDescriptionsStore(),
  () => 1
);
export default getAIDescriptionsStore;
